import React, { useState } from 'react';

function Hero() {
    const [hover, setHover] = useState(false);
  return (
    <section className="support-hero">

      {/* Top row */}
      <div className="support-hero-header">
        <h1>Arthiq Help Center</h1>
        <button
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          style={{
            backgroundColor: hover ? "#5b21b6" : "#7c3aed",
            color: "#fff",
            border: "none",
            padding: "10px 18px",
            borderRadius: "6px",
            fontSize: "16px",
            fontWeight: "500",
            marginTop: "20px",
            cursor: "pointer",
            transition: "0.2s ease",
          }}
        >
            View my support requests
        </button>
      </div>

      {/* Search bar */}
      <div className="support-search-box">
        <span className="search-icon"><i class="fa-solid fa-magnifying-glass"></i></span>
        <input
          type="text"
          placeholder="Search help articles (e.g. How does paper trading work?)"
        />
      </div>

    </section>
  );
}

export default Hero;
